/**
 * @(#)2019/6/17.
 * YxDynamicForm，动态生成表单
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import moment from "moment";
import ReactDOM from "react-dom";
import YxInput from "../YxInput";
import YxPanel from "../YxPanel";
import style from "./index.less";
import { get, cloneDeep, ieVersion, computedStyle } from "../../utils";
import YxAction from "../YxAction";
import React, { Component } from "react";
import request from "../../utils/request";
import MultipleInput from "../MultipleInput";
import { withRouter } from "react-router-dom";
import { Form, Row, Col, message } from "antd";
import { YxComponent, Connection } from "../YxComponent";
import { isArray, isObject, isFunction, set, merge, isEqual } from "lodash";
import { colItemProcess, formItemsFactory } from "./tools";
import YxIncrementForm from "../YxIncrementForm";
import { omit, get as lodashGet } from "lodash";
import { YxDynamicFormPropTypes } from "./IpropType";
/*
 * @param renderingEndCallback {function([buttonIdArray])} 控件渲染完毕后，会返回所有控件的id列表
 * @param requestParam {object} 表单初始的的请求的参数，有该参数时，既为编辑状态表单，请求后的结果将自动反序列化，详见request函数
 * @param change {function(val,id,event,eventData){}} 表单控件值发生变化时的回调函数，返回控件值，以及控件id,当前对象，当前对象的所有信息
 * @param deSerializationData {object} 表单初始需要反序列化的对象
 * @param onFormChange {function} 类似change事件，但会返回整个表单的值
 * @param noPanel {boole} 是否在分组时候显示最外层面版
 * @param setFieldsValueBefore 赋值前调用回调用函数
 * 注意:"添加了groupKey后，提交的时候  字段会变成  key:{id:"..."}
 *       反序列化也需要设置   key.id:"xxx"  或 key:{id:"..."}"
 * @param load 加载完成初始化方法 暴露内部信息
 * @param version {number} 版本号，如果版本号发生变更，会重新请求接口进行反序列化
 * @param pageTitle {string} 主表单的标题
 * @param panelParam {string} 主表单的面板参数，参考YxPanel, 是pageTitle的完全体， 如果我们不需要面板的其它功能， 直接使用pageTitle即可
 * @param isGrid {boole} 是否启用弹性布局模式的表单布局,默认不启用，固定宽度
 * 
 *
 * @param formItemList {array<object>} 平铺式表单项，它的值即普通表单项的所有参数
 * {
          type: "Number",
          coordinate: ["0-0-0", "0-0-1"],
          controlItemParam: {
            id: "NumberID1",
            label: "第一个控件",
            rules: { required: true }
          }
        }
 * @param formItemList[0].coordinate {array || string} 表单项的坐标，支持数组和字符串， 
          必须是  0-0-0 或 0-0-0-0 格式 最少要有3个数字  它们分别代表了  表单索引-行索引-列索引-项索引（项索引可以不写）

 * @param formItemParamList {array<object>} 平铺式参数项的坐标，支持数组和字符串
 * @param formItemParamList[x].coordinate {array<object>} 平铺式参数项的坐标    必须是  0-0-0 格式， 可以写任意位数
 * @param formItemParamList[x].param {object} 平铺式参数项的的具体参数，可以是任意参数
 *
 * @param form {array}  表单组的信息
 * @param form[x].inputDisabled {bool}  是否禁用所有表单控件
 * @param form[x].groupKey {string}  分组添加key字段，这样该分组下的所有控件的id都会以 key.id 组成，这样我们就允许同名id控件了
 * 
 * 注意：添加了groupKey后，提交的时候  字段会变成  key:{id:"..."}
 *       反序列化也需要设置   key.id:"xxx"  或 key:{id:"..."} 
 * 
 * @param form[x].formParam {object}  会直接作用在表单上的属性， 详见antd官方参数表
 * @param form[x].groupParam {object} 分组的面板组件参数， 参数同面板组件（yxPanel）参数一致
 * @param form[x].groupParam.noBorder 可配置分组是否加入yxPanel参数
 * @param form[x].operating {object} 表单的操作信息
 * @param form[x].operating.isMain {boole} 是否为主面板的操作按钮,只能有一个表单设置为主面板按钮
 * @param form[x].operating.buttonList {array} 表单的操作项，一般指的是按钮项
 * @param form[x].operating.buttonList[x].submitRange {string | array} whole | [inputIds]  提交范围，如果是whole则会把所有分组一起提交，如果是数组，则只提交该数组指定的id项
 * @param form[x].operating.buttonList[x] {object} 操作项的其他按钮参数，请参考YxAction组件
 * @param form[x].operating.buttonList[x].requestParam {object}详见request.js函数， 操作项的接口操作，如果有该参数，接口在点击后会发起请求,
 *
 * @param form[x].row {array} 表单的行信息
 * @param form[x].row[x].rowParam {object} 行的参数， 详见antd的row参数表
 * @param form[x].row[x].col {array} 行的列信息
 * @param form[x].row[x].col[x].colType || type {string} 列的多语言类型  如果等于multiple ， 整列就会变成多语言
 * @param form[x].row[x].col[x].controlType {string} input 控件的多语言类型， 默认是输入框模式
 * @param form[x].row[x].col[x].colParam {object} 列的参数，详见antd的col参数表
 * @param form[x].row[x].col[x].controlList {array} 列中的控件组
 * @param form[x].row[x].col[x].controlList[x].type {string} 控件类型 默认String ，类型详见 YxInput的子组件类型
 * @param form[x].row[x].col[x].controlList[x].controlItemParam {object} 控件项的参数， 详见YxInput子组件的参数表
 * @param form[x].row[x].col[x].controlList[x].mutex {object} 表单互斥对象，
 * @param form[x].row[x].col[x].controlList[x].mutex.ids {array<string>} 需要监听的表单项的key值，
 * @param form[x].row[x].col[x].controlList[x].mutex.formId {array<string>}
 * @param form[x].row[x].col[x].controlList[x].mutex.callback {function(object<ids>){return false}} 互斥回调函数，返回所有监听的控件值，如果返回为false则隐藏当前项，
 * @param form[x].row[x].col[x].controlList[x].deserializeCallback {function(val,key,data){ return val}} 反序列化时，处理数值的函数，如有函数则只处理函数，必须要返回内容，会传递3个参数，key对应的值，key，以及整个查询到的data对象
 * @param form[x].row[x].col[x].children {ReactNode} 列的子节点信息， 可以传html或jsx， 如存在该参数，则controlList失效
 * */
let defaul = () => {
  return {
    children: "", //子节点
    isDragTips: false, //是否显示拖拽提示
    formParam: {
      change: () => {},
      version: "", //版本号
      isGrid: true,
    },
  };
};
@withRouter
@Connection(defaul)
class YxDynamicForm extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = { groupDisabled: {} };
    this.inputListId = []; //控件id列表
    this.isChildrenItem = []; //当前表单组是否存在children
    this.oldInputListId = []; //旧id数据，用来判断回调死循环的
    this.version = null; //是否发生过请求
    this.deSerializationCacheName = ""; //存储反序列化的值的缓存中的名字，在组件卸载时必须删掉
    this.deserializations = []; //反序列化需要处理的项 time | date | range 处理类型，如果是Time或Date，会进行时间格式化处理,如果是Range 值必须是[x,x]格式
    this.defaultValues = {}; //保存所有input的defaultValues，用于进行第一次互斥判断
    this.getGroupDisabled();
  }

  getGroupDisabled() {
    let formParam = get(this.props, "formParam");
    let formList = get(formParam, "form", []);
    let result = {};
    formList.forEach((itme, index) => {
      result[index] = get(itme, "inputDisabled", false);
    });
    this.state.groupDisabled = result;
  }

  //获取当前表单项的详细参数，并进行一些处理,主要为了处理groupKey
  itemParam(controlItem, formData) {
    let id = get(controlItem, "controlItemParam.id", "");
    let groupKey = get(formData, "groupKey");
    !id ? console.error("表单项必须包含ID字段") : "";
    //如果开启了groupKey的功能
    if (id && groupKey) {
      set(controlItem, "controlItemParam.id", `${groupKey}.${id}`);
      set(controlItem, "controlItemParam.groupKey", groupKey);
    }
    return controlItem;
  }

  /**
   * 构建表单实时数据方法
   * 通过获取旧值，与change的值合并达到一个完整的值
   *
   * @memberof YxDynamicForm
   */
  runTimeData = (id, value, cbk) => {
    const values = this.props.form.getFieldsValue(
      this.oneArray(this.inputListId)
    );
    set(values, id, value);
    cbk(values);
    return values;
  };

  /*
   * 输出表单控件
   * @param formData {object} form的参数信息
   * @param groupIndex {Number} 分组的索引
   * @param inputDisabled {bool} 是否全局禁用所有控件
   * @return {ReactNode}
   * */
  formItem(formData, groupIndex = null, inputDisabled) {
    let html = [];
    let THIS = this;
    let tmpProps = THIS.props;

    let change = get(tmpProps, "formParam.change", () => {});
    let controlList = (controlItem) => {
      let itemProps = {
        inputType: controlItem.type,
        form: tmpProps.form,
        disabled: inputDisabled,
        ...get(controlItem, "controlItemParam", {}),
        change: (value, id, event, eventData) => {
          change(value, id, event, eventData);
          get(controlItem, "controlItemParam.change", () => {})(
            value,
            id,
            event,
            eventData
          );
          const onFormChange =
            get(tmpProps, "onFormChange", null) ||
            get(tmpProps, "formParam.onFormChange", null);
          onFormChange instanceof Function &&
            this.runTimeData(id, value, onFormChange);
        },
      };
      let list = {
        Number: YxInput.Number, //数字
        String: YxInput.String, //字符串
        TextInput: YxInput.String, //字符串 为了兼容X-m的写法，增加多一套重复的string
        Date: YxInput.Date, //时间，日期
        Phone: YxInput.Phone, //手机，电话
        Password: YxInput.Password, //密码
        Certificates: YxInput.Certificates, //证件
        Select: YxInput.YxSelect, //下拉选择
        TreeSelect: YxInput.YxTreeSelect, //下拉树选择
        EMail: YxInput.EMail, //邮箱
        Url: YxInput.Url, //URL
        Range: YxInput.Range, //输入范围
        Cascader: YxInput.Cascader, //级联
        Radio: YxInput.YxRadio, //单选
        YxRadio: YxInput.YxRadio, //单选
        Switch: YxInput.YxSwitch, //开关
        TextArea: YxInput.TextArea, //文本域
        Upload: YxInput.Upload, //上传
        Checkbox: YxInput.YxCheckbox, //复选
        KindEditor: YxInput.KindEditor, //富文本框
        Search: YxInput.Search, //搜索
        YxPopup: YxInput.YxPopup, //弹出框
        Extend: YxInput.YxExtend, //扩展组件
        ColorPicker: YxInput.YxColorPicker, //取色器
        IncrementForm: YxIncrementForm, //取色器
        YxCode: YxInput.YxCode,
      };
      let Dome = list[get(controlItem, "type", "String")];
      if (controlItem.type == "IncrementForm") {
        // 自增表单类型新增参数
        itemProps.isFormItem = true;
      }
      return <Dome {...omit(itemProps, ["inline"])}></Dome>;
    };
    // 自增表单时传入下标index_
    let controlFuc = (colItem) => {
      let controlData = get(colItem, "controlList", []);
      let controlHtml = [];
      controlData.map((controlItem, key) => {
        controlItem = this.itemParam({ ...controlItem }, formData);
        //收集反序列化信息
        this.deserializationList(controlItem);

        //是否有互斥信息
        let mutex = "";
        if (get(controlItem, "type") == "YxPopup") {
          // 弹出页面mutex需要在controlItemParam里取
          mutex = get(controlItem, "controlItemParam.mutex", "");
        } else {
          mutex = get(controlItem, "mutex", "");
        }

        let ids = get(mutex, "ids", "");
        let { getFieldsValue } = tmpProps.form;
        //解析控件项，收集id
        let pushItem = () => {
          //收集id，用于表单验证
          let itemid = get(controlItem, "controlItemParam.id", "");
          let defaultValue = get(
            controlItem,
            "controlItemParam.defaultValue",
            ""
          );
          THIS.inputListId[groupIndex].push(itemid);
          //收集defaultValue，用于做第一次互斥判断
          defaultValue ? (THIS.defaultValues[itemid] = defaultValue) : "";
          const cellParam = get(controlItem, "cellParam", {});
          //解析控件项
          controlHtml.push(
            <Col
              span={8}
              key={key}
              {...get(colItem, "colParam", {})}
              {...cellParam}
            >
              {controlList(controlItem)}
            </Col>
          );
        };
        //是否有联动互斥信息
        if (mutex && ids) {
          //ToDo 如果未来我们需要，在互斥的时候，对当前的控件项信息进行变更，我们可以在这里将controlItem返回给回调函数经过处理再拿回来
          //把当前互斥信息的值，返回给回调函数
          let cbk = "";
          let defaultIntersection = {}; //交集数据
          if (isObject(this.defaultValues) && isArray(ids)) {
            ids.map((idItem) => {
              if (get(this.defaultValues, idItem)) {
                defaultIntersection[idItem] = this.defaultValues[idItem];
              }
            });
          }
          //把有default的和互斥的值合并
          let fieldValues = merge(defaultIntersection, getFieldsValue(ids));
          if (mutex.formId) {
            cbk = get(mutex, "callback", () => {})(
              get(fieldValues, `[${mutex.formId}]`, {})
            );
          } else {
            cbk = get(mutex, "callback", () => {})(fieldValues);
          }
          //如果回调函数返回值不是false，就显示该项，否则隐藏
          if (cbk !== false) {
            pushItem();
          }
        } else {
          pushItem();
        }
      });
      return controlHtml;
    };
    let colFuc = (colData, idx) => {
      let colHtml = [];
      for (let colItem of colData) {
        const colType = get(colItem, ["colType", "type"], null);
        //如果存在节点信息，则直接显示节点
        let childrenHtml = get(colItem, "children", "");
        //如果存在节点信息，记录下是哪个表单组有节点信息，
        childrenHtml ? (this.isChildrenItem[groupIndex] = true) : "";
        let Dom = null;

        if (!childrenHtml) {
          if (colType === "multiple") {
            const colItem_ = colItemProcess(colItem);
            controlFuc(colItem_);
            Dom = (
              <MultipleInput
                key={idx}
                fun={controlFuc}
                form={this.props.form}
                colItem={colItem_}
              ></MultipleInput>
            );
          } else {
            Dom = controlFuc(colItem);
          }
        } else {
          Dom = (
            <Col span={8} key={idx} {...get(colItem, "colParam", {})}>
              {isFunction(childrenHtml) ? childrenHtml() : childrenHtml}
            </Col>
          );
        }
        colHtml.push(Dom);
      }
      return colHtml;
    };
    get(formData, "row", []).map((rowItem, idx) => {
      html.push(
        <Row
          key={`from-row-${groupIndex}-${idx}`}
          {...get(rowItem, "rowParam", {})}
        >
          {colFuc(get(rowItem, "col", []), idx)}
        </Row>
      );
    });

    return html;
  }

  oneArray = (arr) => {
    let newArr = [];
    arr.map((arrItem) => {
      isArray(arrItem) &&
        arrItem.map((oneArrItem) => {
          newArr.push(oneArrItem);
        });
    });
    return newArr;
  };
  getFormValueRange = () => {
    const values = this.props.form.getFieldsValue(
      this.oneArray(this.inputListId)
    );
    return values;
  };
  /*
   * 判断提交范围，如果是全局提交则验证所有id信息
   * @param item {object} 操作项信息
   * @param groupIndex {number} 分组的索引
   * @return {ReactNode}
   * */
  submitRange(item, groupIndex) {
    //提交范围
    let submitRange = get(item, "submitRange", "");

    let inputIds = [];
    //是否全局提交
    if (submitRange == "whole") {
      inputIds = this.oneArray(this.inputListId);
    } else {
      isArray(submitRange)
        ? (inputIds = submitRange)
        : (inputIds = this.inputListId[groupIndex]);
    }
    return inputIds;
  }
  /*
   * 判断是否有操作项
   * @param buttonList {array} 操作列表信息
   * @param groupIndex {number} 分组的索引
   * @return {ReactNode}
   * */
  buttonList(buttonList, groupIndex = null) {
    let buttonParamArray = []; //action的参数项
    let THIS = this;
    let btnDisabeld = get(this.state.groupDisabled, groupIndex, false);
    let controlList = (item) => {
      let type = get(item, "actionType", "button");

      let itemProps = {
        reset: {
          // icon: "close",
          onClick: async (event) => {
            let tmpProps = THIS.props;
            let { resetFields } = tmpProps.form;
            let { formParam } = tmpProps;
            //如果是编辑状态
            if (get(formParam, "requestParam", "")) {
              this.initialFormRequest(formParam);
            } else {
              resetFields();
            }
          },
        },
        submit: {
          ids: THIS.submitRange(item, groupIndex) || null,
        },
        editShow: {
          text: btnDisabeld ? "编辑 " : "展示",
          actionType: "action",
          onClick: async () => {
            let btnDisabeldBool = get(
              this.state.groupDisabled,
              groupIndex,
              false
            );
            btnDisabeld = !btnDisabeldBool;
            let groupDisabled = this.state.groupDisabled;
            groupDisabled[groupIndex] = !btnDisabeldBool;
            await this.setState({ groupDisabled });
          },
        },
      };
      //let control = <YxButton {...itemProps[type]} />;
      //delete item.type;

      let actionParam = {
        ...item,
        ...get(itemProps, type, {}),
      };
      delete actionParam.submitRange; //删掉多余数据
      return actionParam;
    };
    buttonList.map((item) => {
      buttonParamArray.push(controlList(item));
    });
    let html = <YxAction form={this.props.form} group={buttonParamArray} />;
    html = buttonList.length > 0 ? html : "";

    return html;
  }

  //处理面板参数信息
  /*
   *@param formDataItem {object} 当前表单项的所有参数
   *@param index {number} 当前表单项在表单组中的索引
   *@param formList {array<object>} 表单组信息
   */
  panelParam(formDataItem, index, formList) {
    let param = get(formDataItem, "groupParam", {});
    let buuttonData = get(formDataItem, "operating.buttonList", []);
    let isFootElement =
      String(get(param, "footerNode.$$typeof", false)) ==
      "Symbol(react.element)";
    //兼容以前的旧语法
    if (!get(param, "header", "")) {
      param.header = get(formDataItem, "pageTitle.text", "");
    }
    if (formList.length > 1) {
      if (get(formDataItem, "operating.isMain", "")) {
        //把按钮转移到主面板
        this.mainAction = (
          <div className="yx_DynamicForm_mainActionTop">
            {this.buttonList(buuttonData, index)}
          </div>
        );
      } else {
        param.footerNode = this.buttonList(buuttonData, index);
        // !isFootElement
        //   ? (param.footerNode = this.buttonList(buuttonData, index))
        //   : "";
      }
    } else {
      //设置action到foot
      // !isFootElement
      param.footerNode = this.buttonList(buuttonData, index);
      // : "";
    }
    return param;
  }

  //判断是否有分组信息
  group(formData) {
    let html = [];
    let THIS = this;
    let tmpProps = THIS.props;
    let formList = get(formData, "form", []);
    //清空input信息
    //循环表单
    formList.map((item, index) => {
      //初始设置控件列表
      THIS.inputListId[index] = [];
      //节点信息初始置空
      this.isChildrenItem[index] = "";
      // let inputDisabled = get(item, "inputDisabled", false); //是否全局控件禁用
      let inputDisabled = get(this.state.groupDisabled, index, false);
      let formParam = get(item, "formParam", {}); //直接作用在form上的参数
      let formItemHtml = this.formItem(item, index, inputDisabled); //生成表单项
      let groupParam = this.panelParam(item, index, formList); //处理面板参数

      //如果存在分组信息
      if (formList.length > 1) {
        !get(groupParam, "styleParam.type", "")
          ? set(groupParam, "styleParam.type", "border")
          : "";
        //给每一位面板提供上边距
        set(groupParam, "className", "yx_yxFormMarginTop");
      }

      //如果当前表单组什么表单项也没有，且也没有节点，则不显示该面板
      THIS.inputListId[index].length > 0 || this.isChildrenItem[index]
        ? html.push(
            // <Form key={index} {...formParam}>外层已使用 @Form.create() 内部不需要
            <div key={index} {...formParam}>
              {/* noBorder可配置是否添加分组外边框 */}
              {!get(item, "groupParam.noBorder") ? (
                <YxPanel {...groupParam}>{formItemHtml}</YxPanel>
              ) : (
                formItemHtml
              )}
            </div>
          )
        : "";
    });

    //添加主面板
    if (formList.length > 1 && !this.props.formParam.noPanel) {
      let panelParam = get(formData, "panelParam", false);
      let defaulParam = {
        header: get(formData, "pageTitle", ""),
        footerNode: this.mainAction,
      };
      if (panelParam) {
        defaulParam = merge(defaulParam, panelParam);
      }
      html = <YxPanel {...defaulParam}>{html}</YxPanel>;
    }
    return html;
  }

  //根据每一项控件配置，搜集需要特殊处理的项，在反序列化的时候，需要对其进行数值处理
  //目前只处理date,time,Upload,和range,select,TreeSelect 多选模式
  deserializationList(item) {
    let obj = {
      type: "", //处理类型
      key: get(item, "controlItemParam.id", ""), //对应的字段，和控件id对应
      callback: null, //处理回调函数,
      inputParam: get(item, "controlItemParam.inputParam", {}),
    };
    let type = get(item, "type", "");
    if (type == "Date") {
      let formatType = {
        Time: "HH:mm:ss",
        Date: "YYYY-MM-DD HH:mm:ss",
      };
      let format = get(item, "controlItemParam.format", false);
      let itemType = get(item, "controlItemParam.type", "");
      itemType == "time" || itemType == "timeRange"
        ? (obj.type = "Time")
        : (obj.type = "Date");
      obj.format = format ? format : formatType[obj.type];
    }
    if (type == "Range" || type == "Upload") {
      obj.type = type;
    }
    if (type === "Select" || type === "TreeSelect") {
      obj.type = type;
    }
    if (get(item, "deserializeCallback", "")) {
      obj.callback = get(item, "deserializeCallback", "");
    }
    if ((obj.key && obj.callback) || obj.key) {
      this.deserializations.push(obj);
    }
  }

  //反序列化数据到表单中，并进行相应的值处理
  setInputValue(data = {}) {
    let { setFieldsValue, getFieldsValue, resetFields } = this.props.form;
    let deserializations = this.deserializations;
    let setValue = {};
    if (isObject(data)) {
      deserializations.map((item) => {
        let type = get(item, "type", "");
        let key = get(item, "key", "");
        let callback = get(item, "callback", "");
        let format = get(item, "format", false);
        let currentItem = lodashGet(data, key); //当前项数据
        // let currentItem = data[key];
        //如果存在处理的回调函数
        //查询序列化对象中，是否有当前处理项的字段
        if (currentItem !== null && currentItem !== undefined) {
          // if (currentItem || currentItem === 0 || currentItem === false) {
          if (isFunction(callback)) {
            currentItem = callback(currentItem, data, key);
          }
          if (type == "Time" || (type == "Date" && format)) {
            if (currentItem instanceof Array) {
              let dateArr = [];
              currentItem.map((dateItem, index) => {
                if (dateItem) {
                  dateArr[index] = moment(dateItem, format);
                }
              });
              currentItem = dateArr;
            } else if (data[key]) {
              currentItem = moment(data[key], format);
            }
          }
          if (type == "Upload" && !isArray(currentItem)) {
            console.error(
              "Upload的反序列化值必须为[url,...],格式,当前值的格式为：" +
                JSON.stringify(currentItem)
            );
          }
          if (
            type == "Range" &&
            (!isArray(currentItem) || currentItem.length < 2)
          ) {
            console.error(
              "Range的反序列化值必须为[Number,Number],格式,当前值的格式为：" +
                JSON.stringify(currentItem)
            );
          }

          //处理下拉多选参数类型
          if (type === "Select") {
            let mode = get(item, "inputParam.mode");
            if (mode === "multiple" && !isArray(currentItem)) {
              console.error(
                "Select[mode=multiple] 多选模式 反序列化数据为数组格式,当前值的格式为：" +
                  JSON.stringify(currentItem)
              );
              currentItem = [];
            }
          }
          // 树型下拉
          if (type === "TreeSelect") {
            let mode = get(item, "inputParam.multiple");
            let checkable = get(item, "inputParam.treeCheckable");
            if (!isArray(currentItem) && (mode || checkable)) {
              console.error(
                "TreeSelect[multiple=true] 多选模式 反序列化数据为数组格式,当前值的格式为：" +
                  JSON.stringify(currentItem)
              );
              currentItem = [];
            }
          }
          getFieldsValue([key]); //加上这句，能够去掉因为Input不存在报waing的bug
          if (key) {
            setValue[key] = currentItem;
          }
        }
      });
    }
    //反序列化前的回调，用于先清空非必要的字段项
    let setFieldsValueBefore =
      get(this.props, "setFieldsValueBefore", null) ||
      get(this.props, "formParam.setFieldsValueBefore", null);
    isFunction(setFieldsValueBefore) ? setFieldsValueBefore(resetFields) : "";
    setFieldsValue(setValue);
  }

  //初始执行数据加载函数,并且反序列化
  async initialFormRequest() {
    let { formParam } = this.props;
    //查询请求参数
    let requestParam = get(formParam, "requestParam", "");
    if (requestParam && get(requestParam, "url")) {
      this.version = formParam.version;
      let { data } = await request(requestParam);
      this.setInputValue(data);
    }
  }

  //表单主动进行反序列化
  //deSerialization 需要反序列化的值
  formDeSerialization(deSerialization = false) {
    let cacheName = this.deSerializationCacheName; //缓存名
    let deSerializationCache = localStorage.getItem(cacheName); //缓存
    if (
      deSerialization &&
      JSON.stringify(deSerialization) != deSerializationCache
    ) {
      localStorage.setItem(cacheName, JSON.stringify(deSerialization));
      // setTimeout(() => {
      this.setInputValue(deSerialization);
      // }, 100);
    }
  }

  productionHtml() {
    let tmpProps = { ...this.props };
    let formParam = get(tmpProps, "formParam");
    let formItemList = get(tmpProps, "formParam.formItemList"); //平铺式参数项
    //如果存在平铺式的参数组，formItems,则进行一次处理，将其处理为原本我们所需的格式
    formItemList && isArray(formItemList)
      ? (formParam = formItemsFactory(formParam))
      : "";

    //清空表单控件ID数据
    this.inputListId = [];
    //清空反序列化处理数组
    this.deserializations = [];
    if (!formParam) {
      return "参数缺少层级formParam，所有表单参数应该包含在formParam中";
    }
    let deSerializationData = get(formParam, "deSerializationData", false);
    let html = "";
    html = this.group(formParam);
    //执行回调函数，返回当前表单的所有控件信息
    if (
      JSON.stringify(this.inputListId) != JSON.stringify(this.oldInputListId)
    ) {
      this.oldInputListId = this.inputListId;
      get(formParam, "renderingEndCallback", () => {})(this.inputListId);
    }
    //初始执行数据加载函数
    this.version !== formParam.version ? this.initialFormRequest() : "";

    //初始进行主动反序列化
    // TODO 在这里反序列化可能会报一个waning，因为控件可能还没有被渲染出来，要考虑顺序的问题，所以要使用setTimeout来解决
    setTimeout(() => {
    deSerializationData ? this.formDeSerialization(deSerializationData) : "";
    }, 100);
    return html;
  }
  componentDidMount() {
    const { load = () => {} } = this.props;
    load(this.getFormValueRange);
  }

  //第一次执行组件
  componentWillMount() {
    this.deSerializationCacheName =
      "yx_widget_deSerializationDataName_" + parseInt(Math.random() * 10000000);
  }
  // shouldComponentUpdate(nextProps) {
  //   if (
  //     !isEqual(
  //       nextProps.formParam.deSerialization,
  //       this.props.formParam.deSerialization
  //     )
  //   ) {
  //     this.formDeSerialization(nextProps.formParam.deSerializatio);
  //   }
  //   return true;
  // }
  //卸载组件
  componentWillUnmount() {
    //清除反序列化的缓存名
    localStorage.removeItem(this.deSerializationCacheName);
  }

  get divClass() {
    let ieVersionClass =
      ieVersion() < 0 || ieVersion() == "edge" ? "yx_YxDynamicFormNoneIe" : ""; //浏览器类型, ie下，col的宽度失效，不能使用auto
    return `yx_YxDynamicForm ${ieVersionClass} ${
      get(this.props.formParam, "isGrid") ? "yx_YxDynamicFormNoneGrid" : ""
    } ${this.props.noSymbol ? "yx_yxFormitem_horizontal_noncolon" : ""}`;
  }

  /**
   * 显示可拖拽的提示区域
   */
  dragTipsHtml() {
    return (
      <div className="yx_YxDynamicForm_dragTips">
        输入子组件可以拖拽到该区域
      </div>
    );
  }

  render() {
    return (
      <div className={this.parentClass}>
        {this.productionHtml()}
        {this.props.isDragTips == true ? this.dragTipsHtml() : ""}
      </div>
    );
  }
}

YxDynamicForm.propTypes = YxDynamicFormPropTypes;
YxDynamicForm.defaultProps = defaul();
export default YxDynamicForm;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxDynamicForm/index.js